import { Consultation, Weight } from '@app/core/models';

export interface PetState {
  consultationsWithoutVisit: Consultation[];
  growthChartData: GrowthChartData;
}

export const initialPetState: PetState = {
  consultationsWithoutVisit: [],
  growthChartData: { chartImage: null, chartWeights: [], notSavedPastWeights: [] },
};

export interface GrowthChartData {
  chartImage: string;
  chartWeights?: Weight[];
  notSavedPastWeights?: Weight[];
}
